// extracted by mini-css-extract-plugin
export default {"row":"Earning_row__BfpGw","col":"Earning_col__r2er+","card":"Earning_card__KGv8u"};